<template>
  <div class="input_container">
    <van-field v-model="inputValue" right-icon="user-circle-o"
      :style="{ border: props.isShowError ? '1.5px red solid' : '0.5px solid rgba(221, 122, 51, 0.5)' }"
      :type="isShow && props.isPassword ? 'text' : props.fieldType" :maxlength="props.isPassword ? 20 : 'none'"
      :placeholder="props.labelText">
      <template #right-icon>
        <div v-if="props.isPassword">
          <img v-if="isShow" src="../../../assets/loginRegister/showEye.png" alt="" width="18px" class="iconImage"
            @click="handleShowPassword" />
          <img v-else src="../../../assets/loginRegister/hideEye.png" alt="" width="18px" class="iconImage"
            @click="handleShowPassword" />
        </div>
      </template>

      <template #left-icon>
        <div class="leftContainer" v-if="!props.isPassword && props.isshowFlag">
          <img src="../../../assets/loginRegister/br_flag.png" alt="" />
          <p class="currencyText">+55</p>
          <div class="line"></div>
        </div>
        <div v-if="props.isPassword" class="leftContainer">
          <img src="../../../assets/loginRegister/lock.png" alt="" width="18px">
        </div>
      </template>
    </van-field>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, watch, defineEmits } from 'vue'
import type { FieldType } from 'vant'

const props = defineProps({
  fieldType: {
    type: String as () => FieldType,
    default: () => 'text'
  },
  isPassword: {
    type: Boolean,
    default: () => false
  },
  labelText: {
    type: String,
    default: () => ''
  },
  isshowFlag: {
    type: Boolean,
    default: () => false
  },
  isShowError: {
    type: Boolean,
    default: () => false
  }
})

const isShow = ref(false)
const inputValue = ref('')

const emit = defineEmits(['valueChanged'])


watch(() => inputValue.value, (newValue: string) => {
  emit('valueChanged', newValue)
});

const handleShowPassword = () => {
  isShow.value = !isShow.value
}


</script>
<style scoped>
.input_container>>>.van-field {
  border-radius: 30px;
  background: #2C1D0F;
  /* border: 0.5px solid rgba(221, 122, 51, 0.5); */
  color: #ffffffd9;
  padding: 12px 15px !important;
  margin-top: 10px;
}

.input_container>>>.van-field__control {
  color: #fff !important;
  padding-left: 10px !important;
}

.input_container>>>.van-field__control::placeholder {
  color: #ffffff40 !important;
  font-family: monospace;
}

.input_container>>>.van-field__right-icon {
  color: #ffffff40 !important;
}

.leftContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.currencyText {
  color: #ffffffa6;
  font-family: monospace;
  padding: 0 5px;
  margin: 0;
}

.leftContainer img {
  width: 25px;
}

.line {
  width: 1px;
  background-color: rgba(255, 255, 255, 0.65);
  height: 15px;
  margin-right: 5px;
}
</style>